<div class="row" *ngIf="current.type != 'Connector' && current.type != 'RinneWand'">
	<div class="col col-4"><span i18n="Common|Length">Length</span>:</div>
	<div class="col col-8">
		<app-numeric-textbox [value]="current.length" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row" *ngIf="current.type == 'Bar' || current.type == 'SideFinish'">
	<div class="col col-4"><span i18n="Common|Cover length">Cover length</span>:</div>
	<div class="col col-8">
		<app-numeric-textbox [value]="projectService.template.deckelLength" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span *ngIf="current.orientation == 'Horizontal'"><span i18n="Common|Location y">Location y</span>:</span>
		<span *ngIf="current.orientation == 'Vertical'"><span i18n="Common|Location x">Location x</span>:</span>
	</div>

	<div class="col col-8">
		<app-numeric-textbox #numLoc [value]="currentProfileLocation" [disabled]="projectService.readOnly || (current.type != 'ProfileConnector' && (changeLocationDisabled() || checkFreezingElements()))"
			[min]="minXLocation" [max]="maxXLocation" [delay]="200"
		></app-numeric-textbox> mm
	</div>
</div>

<div *ngIf="current.type == 'Bar' || current.type == 'ProfileConnector' || current.type == 'WallGutter'">
	<div class="row">
		<div class="col col-4">
			<span i18n="Common|Delete">Locked</span>:
		</div>
		<div class="col col-8">
			<input type="checkbox" kendoCheckBox style="width: 20px; height: 20px;" [(ngModel)]="current.locked" [disabled]="projectService.readOnly">
		</div>
	</div>

	<div class="row">
		<div class="col col-4">
			<span i18n="Common|Delete">Delete</span>:
		</div>
		<div class="col col-8">
			<button kendoButton [svgIcon]="projectService.svgIcons.trashIcon" (click)="deleteElement()" [disabled]="projectService.readOnly || (current.type != 'ProfileConnector' && checkFreezingElements())" i18n="Common|Delete">Delete</button>
		</div>
	</div>
</div>

<card-cuttingonsite [current]="current" [disabled]="checkFreezingElements()"></card-cuttingonsite>
<card-in-offer [current]="current"></card-in-offer>

<div *ngIf="projectService.showDebugInfo" class="testMode">
	<div class="row">
		<div class="col col-4">Id:</div>
		<div class="col col-8">{{ current.id }}</div>
	</div>
	<div *ngIf="current.type == 'WallProfile'">
		<div class="row">
			<div class="col col-4">Tag:</div>
			<div class="col col-8">{{ current.tag }}</div>
		</div>
		<div class="row">
			<div class="col col-4">Columns:</div>
			<div class="col col-8">
				<p *ngFor="let c of current.columns">
					{{ c.tag}}: {{ c.id }}
				</p>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="current.type != 'WallProfile'">
		<div class="col col-4">Min location:</div>
		<div class="col col-8">{{ minXLocation }}</div>
	</div>
	<div class="row" *ngIf="current.type != 'WallProfile'">
		<div class="col col-4">Max location:</div>
		<div class="col col-8">{{ maxXLocation }}</div>
	</div>
	<div class="row" *ngIf="current.type == 'Bar' || current.type == 'SideFinish'">
		<div class="col col-4">Left glasses:</div>
		<div class="col col-8">{{ current.leftGlasses?.[0]?.id }}<br>{{ current.leftGlasses?.[1]?.id }}</div>
	</div>
	<div class="row" *ngIf="current.type == 'Bar' || current.type == 'SideFinish'">
		<div class="col col-4">Right glasses:</div>
		<div class="col col-8">{{ current.rightGlasses?.[0]?.id }}<br>{{ current.rightGlasses?.[1]?.id }}</div>
	</div>
</div>

